module.exports = __webpack_public_path__ + "static/media/phone-mobile.bb2e1f87.png";